import type { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { timeout } from 'rxjs';
import { angularjs } from '@app/service/migration-helpers/angularjs.injection';
import type { IContentStore } from '@app/interface/content/content-store.interface';
import { DEFAULT_HTTP_TIMEOUT } from '@app/interceptor';

@Injectable()
export class HttpTimeoutInterceptor implements HttpInterceptor {
  private contentStore: IContentStore = inject<IContentStore>(angularjs.ContentStore);
  constructor() {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const timeoutValue = this.contentStore.getConfig().httpRequestTimeout ?? DEFAULT_HTTP_TIMEOUT;
    const timeoutValueNumeric = Number(timeoutValue);

    return next.handle(req).pipe(timeout(timeoutValueNumeric));
  }
}
